<template>
  <el-form
    ref="ruleForm"
    :model="item"
    label-position="left"
    label-width="160px"
  >
    <el-divider>
      <span class="blue"> Companion AD </span>
    </el-divider>
    <el-form-item label="Enable">
      <el-switch v-model="item.companion_enable" @change="initCompanion()">
      </el-switch>
    </el-form-item>
    <el-form-item label="Type" v-if="item.companion_enable">
      <el-radio-group
        v-model="item.companion_type"
        @change="resetCompanionData()"
      >
        <el-radio label="image">Image</el-radio>
        <el-radio label="html">Html</el-radio>
      </el-radio-group>
    </el-form-item>
    <el-form-item
      v-if="item.companion_enable"
      label="Companion Size"
      prop="companion_size"
      :rules="sizeRule('size')"
    >
      <el-select
        v-model="item.companion_size"
        filterable
        allow-create
        clearable
      >
        <el-option
          v-for="opt in sizeOption"
          :key="opt"
          :label="opt"
          :value="opt"
        ></el-option>
      </el-select>
    </el-form-item>
    <el-form-item
      v-if="item.companion_enable && item.companion_type === 'image'"
      label="Image"
      prop="companion_data"
      :rules="urlRule('image_url')"
    >
      <file-input
        accept="image/jpeg, image/png"
        v-model="item.companion_data"
      ></file-input>
    </el-form-item>
    <el-form-item
      v-else-if="item.companion_enable && item.companion_type === 'html'"
      label="Html"
      prop="companion_data"
    >
      <el-input
        type="textarea"
        :autosize="{ minRows: 4, maxRows: 10 }"
        placeholder="please input html code"
        v-model="item.companion_data"
      >
      </el-input>
    </el-form-item>
    <el-divider>
      <span class="blue">Video</span>
    </el-divider>
    <el-form-item
      label="Video Url"
      prop="video_url"
      :rules="urlRule('video_url')"
    >
      <file-input
        accept="video/mp4"
        v-model="item.video_url"
        is_original
      ></file-input>
    </el-form-item>
    <el-form-item label="Skip Video" prop="skip_video">
      <el-switch v-model="item.skip_video"></el-switch>
    </el-form-item>
    <el-form-item label="Skip Offset" prop="skip_offset" v-if="item.skip_video">
      <el-input
        v-model.number="item.skip_offset"
        :min="0"
        :max="30"
        type="number"
      >
        <template slot="append">
          <label>seconds</label>
        </template>
      </el-input>
    </el-form-item>
    <el-divider>
      <span class="blue">
        Video Trackings
      </span>
    </el-divider>
    <el-form-item
      label="click"
      prop="video_trackings.click"
      :rules="urlRule('video_trackings.click', false)"
    >
      <el-input v-model="item.video_trackings.click"></el-input>
    </el-form-item>
    <el-form-item
      label="start"
      prop="video_trackings.start"
      :rules="urlRule('video_trackings.start', false)"
    >
      <el-input v-model="item.video_trackings.start"></el-input>
    </el-form-item>
    <form-item-group
      title="impression"
      :min="0"
      :max="5"
      v-model="item.video_trackings.impression"
    >
      <template v-slot="{ index }">
        <el-form-item
          label="impression"
          :prop="`video_trackings.impression.${index}`"
          :rules="urlRule(`video_trackings.impression`)"
        >
          <el-input v-model="item.video_trackings.impression[index]"></el-input>
        </el-form-item>
      </template>
    </form-item-group>
    <form-item-group
      title="impression5s"
      :min="0"
      :max="5"
      v-model="item.video_trackings.impression5s"
    >
      <template v-slot="{ index }">
        <el-form-item
          label="impression 5s"
          :prop="`video_trackings.impression5s.${index}`"
          :rules="urlRule(`video_trackings.impression5s`)"
        >
          <el-input
            v-model="item.video_trackings.impression5s[index]"
          ></el-input>
        </el-form-item>
      </template>
    </form-item-group>
    <form-item-group
      title="firstQuartile"
      :min="0"
      :max="5"
      v-model="item.video_trackings.firstQuartile"
    >
      <template v-slot="{ index }">
        <el-form-item
          label="firstQuartile"
          :prop="`video_trackings.firstQuartile.${index}`"
          :rules="urlRule(`video_trackings.firstQuartile`)"
        >
          <el-input
            v-model="item.video_trackings.firstQuartile[index]"
          ></el-input>
        </el-form-item>
      </template>
    </form-item-group>
    <form-item-group
      title="midpoint"
      :min="0"
      :max="5"
      v-model="item.video_trackings.midpoint"
    >
      <template v-slot="{ index }">
        <el-form-item
          label="midpoint"
          :prop="`video_trackings.midpoint.${index}`"
          :rules="urlRule(`video_trackings.midpoint`)"
        >
          <el-input v-model="item.video_trackings.midpoint[index]"></el-input>
        </el-form-item>
      </template>
    </form-item-group>
    <form-item-group
      title="thirdQuartile"
      :min="0"
      :max="5"
      v-model="item.video_trackings.thirdQuartile"
    >
      <template v-slot="{ index }">
        <el-form-item
          label="thirdQuartile"
          :prop="`video_trackings.thirdQuartile.${index}`"
          :rules="urlRule(`video_trackings.thirdQuartile`)"
        >
          <el-input
            v-model="item.video_trackings.thirdQuartile[index]"
          ></el-input>
        </el-form-item>
      </template>
    </form-item-group>
    <form-item-group
      title="complete"
      :min="0"
      :max="5"
      v-model="item.video_trackings.complete"
    >
      <template v-slot="{ index }">
        <el-form-item
          label="complete"
          :prop="`video_trackings.complete.${index}`"
          :rules="urlRule(`video_trackings.complete`)"
        >
          <el-input v-model="item.video_trackings.complete[index]"></el-input>
        </el-form-item>
      </template>
    </form-item-group>
    <el-form-item
      label="skip"
      prop="video_trackings.skip"
      :rules="urlRule('video_trackings.skip', false)"
    >
      <el-input v-model="item.video_trackings.skip"></el-input>
    </el-form-item>
  </el-form>
</template>

<script>
import MixCreativeForm from '@/components/mixins/creativeForm';
import { mapState } from 'vuex';
import { VASTParser } from 'vast-client';
import FileInput from '@/components/base/forms/fileInput';
import MixFormRule from '@/components/mixins/formRule';
import FormItemGroup from '../formItemGroup.vue';

export default {
  data() {
    return {
      sizeOption: [
        '300x250',
        '336x280',
        '320x50',
        '728x90',
        '300x100',
        '320x100',
        '160x600',
        '300x600',
        '320x480',
        '610x100',
        '970x250',
        '960x100',
      ],
      item: {
        type: '',
        video_url: '',
        skip_video: false,
        skip_offset: '',
        companion_type: 'image',
        companion_data: '',
        companion_size: '',
        companion_enable: false,
        video_trackings: {
          click: '',
          start: '',
          impression: [],
          impression5s: [],
          firstQuartile: [],
          midpoint: [],
          thirdQuartile: [],
          complete: [],
          skip: '',
        },
      },
    };
  },
  mixins: [MixCreativeForm, MixFormRule],
  components: {
    FileInput,
    FormItemGroup,
  },
  computed: {
    ...mapState({
      assets: (state) => state.asset.assets,
    }),
  },
  methods: {
    async setData(row) {
      const vastParser = new VASTParser();
      const domParser = new DOMParser();
      const vast_xml = domParser.parseFromString(row.vast_xml, 'text/xml');
      const res = await vastParser.parseVAST(vast_xml);
      const { creatives, impressionURLTemplates } = res.ads[0];

      const companion_creative = creatives.find(
        (creative) => creative.type === 'companion'
      );
      if (companion_creative) {
        this.item.companion_enable = true;
        const variation = companion_creative.variations[0];
        const companion_height = variation.height;
        const companion_width = variation.width;
        this.item.companion_size = `${companion_width}x${companion_height}`;
        if (variation.type.includes('image')) {
          this.item.companion_type = 'image';
          this.item.companion_data = decodeURI(variation.staticResource);
        } else if (variation.type.includes('html')) {
          this.item.companion_type = 'html';
          this.item.companion_data = variation.htmlResource;
        }
      }

      if (impressionURLTemplates && impressionURLTemplates[2]) {
        this.item.video_trackings.impression = impressionURLTemplates
          .filter(
            (impression, index) =>
              index >= 2 && index < impressionURLTemplates.length - 1
          )
          .map((impression) => decodeURI(impression));
      }
      const {
        skipDelay,
        mediaFiles,
        videoClickTrackingURLTemplates,
        trackingEvents,
      } = creatives.find((creative) => creative.type === 'linear');
      this.item.skip_video = typeof skipDelay === 'number' ? true : false;
      this.item.skip_offset = skipDelay;
      this.item.video_trackings.click = videoClickTrackingURLTemplates[3]
        ? decodeURI(videoClickTrackingURLTemplates[3])
        : '';
      this.item.video_trackings.start = trackingEvents.start[1]
        ? decodeURI(trackingEvents.start[1])
        : '';
      if (
        trackingEvents.viewable_impression &&
        trackingEvents.viewable_impression[3]
      ) {
        this.item.video_trackings.impression = trackingEvents.viewable_impression
          .filter((impression, index) => index >= 3)
          .map((impression) => decodeURI(impression));
      }
      if (trackingEvents['progress-5'][1]) {
        this.item.video_trackings.impression5s = trackingEvents['progress-5']
          .filter((impression5s, index) => index >= 1)
          .map((impression5s) => decodeURI(impression5s));
      }
      if (trackingEvents.firstQuartile[1]) {
        this.item.video_trackings.firstQuartile = trackingEvents.firstQuartile
          .filter((firstQuartile, index) => index >= 1)
          .map((firstQuartile) => decodeURI(firstQuartile));
      }
      if (trackingEvents.midpoint[1]) {
        this.item.video_trackings.midpoint = trackingEvents.midpoint
          .filter((midpoint, index) => index >= 1)
          .map((midpoint) => decodeURI(midpoint));
      }
      if (trackingEvents.thirdQuartile[1]) {
        this.item.video_trackings.thirdQuartile = trackingEvents.thirdQuartile
          .filter((midpoint, index) => index >= 1)
          .map((thirdQuartile) => decodeURI(thirdQuartile));
      }
      if (trackingEvents.complete[1]) {
        this.item.video_trackings.complete = trackingEvents.complete
          .filter((complete, index) => index >= 1)
          .map((complete) => decodeURI(complete));
      }

      this.item.video_trackings.skip = trackingEvents.skip[1]
        ? decodeURI(trackingEvents.skip[1])
        : '';
      this.item.video_url = decodeURI(mediaFiles[0].fileURL);
    },
    async getData(setObj) {
      const {
        video_url,
        skip_offset,
        video_trackings,
        companion_type,
        companion_data,
        companion_enable,
      } = this.item;
      const video_duration = await this.get_duration(video_url);
      let firstQ_sec = Math.floor(video_duration / 4);
      let midpoint_sec = Math.floor(video_duration / 2);
      let thirdQ_sec = Math.floor(video_duration * 0.75);
      let complete_sec = Math.floor(video_duration);
      let IMPRESSION_EVENTS = `<Impression><![CDATA[{{IMPRESSION_TRACKING}}]]></Impression>
            <Impression><![CDATA[{{THIRD_PARTY_IMPRESSION_MACRO}}]]></Impression>`;
      let TRACKING_EVENTS = `<Tracking event='start'><![CDATA[{{VIDEO_START}}]]></Tracking>
        <Tracking event='progress' offset='00:00:05'><![CDATA[{{VIDEO_IMPRESSION_5S}}]]></Tracking>
        <Tracking event='firstQuartile'><![CDATA[{{VIDEO_FIRST_QUARTILE}}?sec=${firstQ_sec}]]></Tracking>
        <Tracking event='midpoint'><![CDATA[{{VIDEO_MIDPOINT}}?sec=${midpoint_sec}]]></Tracking>
        <Tracking event='thirdQuartile'><![CDATA[{{VIDEO_THIRD_QUARTILE}}?sec=${thirdQ_sec}]]></Tracking>
        <Tracking event='complete'><![CDATA[{{VIDEO_COMPLETE}}?sec=${complete_sec}]]></Tracking>
        <Tracking event='skip'><![CDATA[{{VIDEO_SKIP}}]]></Tracking>`;
      let VIDEO_CLICKS = `<ClickTracking><![CDATA[{{VIDEO_CLICK}}]]></ClickTracking>
        <ClickTracking><![CDATA[{{CLICK_TRACKING}}]]></ClickTracking>
        <ClickTracking><![CDATA[{{THIRD_PARTY_CLICK_MACRO}}]]></ClickTracking>`;
      if (setObj.landing_page) {
        VIDEO_CLICKS += `<ClickThrough><![CDATA[${
          setObj.landing_page.replace(/[^\x00-\x7F]/g, (c) => encodeURI(c))
        }]]></ClickThrough>`;
      }
      const SKIPOFFSET = this.item.skip_video
        ? `skipoffset='${moment.utc(skip_offset * 1000).format('HH:mm:ss')}'`
        : '';

      const resp = await Promise.all([
        this.get_video_info(video_url),
        this.get_duration(video_url),
      ]);
      const { mime_type, size, width, height } = resp[0];
      const duration = resp[1];
      const bitrate = Math.round((size * 8) / 1024 / duration);
      let MEDIA_FILE = '';
      _.forEach(video_trackings, (v, k) => {
        if (!v) return;
        const smartEncode = (url) => url.replace(/[^\x00-\x7F]/g, (c) => encodeURI(c));
        if (k === 'impression') {
          v.forEach((ele) => {
            IMPRESSION_EVENTS += `<Impression><![CDATA[${smartEncode(
              ele
            )}]]></Impression>`;
          });
        } else if (k === 'impression5s') {
          v.forEach((ele) => {
            TRACKING_EVENTS += `<Tracking event='progress' offset='00:00:05'><![CDATA[${smartEncode(
              ele
            )}]]></Tracking>`;
          });
        } else if (k === 'click') {
          VIDEO_CLICKS += `<ClickTracking><![CDATA[${smartEncode(
            v
          )}]]></ClickTracking>`;
        } else {
          if (Array.isArray(v)) {
            v.forEach((ele) => {
              TRACKING_EVENTS += `<Tracking event='${k}'><![CDATA[${smartEncode(
                ele
              )}]]></Tracking>`;
            });
          } else {
            TRACKING_EVENTS += `<Tracking event='${k}'><![CDATA[${smartEncode(
              v
            )}]]></Tracking>`;
          }
        }
      });
      if (video_url.includes(config.cdn_url)) {
        MEDIA_FILE = `<MediaFile width='${width}' height='${height}' type='${mime_type}' bitrate='${bitrate}' delivery='progressive'>
        <![CDATA[${video_url.replace(/[^\x00-\x7F]/g, (c) => encodeURI(c))}]]></MediaFile>`;
      }
      const companion = this.parseCompanionToVast(
        companion_enable,
        companion_type,
        companion_data,
        setObj.landing_page.replace(/[^\x00-\x7F]/g, (c) => encodeURI(c)),
        video_trackings.click
      );
      setObj.vast_xml = `<VAST version='3.0'>
        <Ad id='{{ADSESSION_ID}}'>
          <InLine>
            <AdSystem>ucfunnel</AdSystem>
            ${IMPRESSION_EVENTS}
            <Creatives>
              ${companion}
              <Creative>
                <Linear ${SKIPOFFSET}>
                  <Duration>${moment
                    .utc(duration * 1000)
                    .format('HH:mm:ss')}</Duration>
                  <TrackingEvents>
                    ${TRACKING_EVENTS}
                  </TrackingEvents>
                  <VideoClicks>
                    ${VIDEO_CLICKS}
                  </VideoClicks>
                  <MediaFiles>
                    ${MEDIA_FILE}
                  </MediaFiles>
                </Linear>
              </Creative>
            </Creatives>
          </InLine>
        </Ad>
      </VAST>`;
      return setObj;
    },

    async get_video_info(url) {
      const response = await fetch(url);
      const size = response.headers.get('Content-Length');
      const mime_type = response.headers.get('Content-type');
      const blob = await response.blob();
      const video = document.createElement('video');
      video.src = URL.createObjectURL(blob);

      return new Promise((resolve) => {
        video.addEventListener('loadedmetadata', () => {
          resolve({
            width: video.videoWidth,
            height: video.videoHeight,
            size,
            mime_type,
          });
        });
      }).catch((error) => Promise.reject(error));
    },
    get_duration(url) {
      return new Promise((resolve) => {
        const video = document.createElement('video');
        video.src = url;
        video.addEventListener('loadedmetadata', () => {
          resolve(video.duration);
        });
      }).catch((error) => Promise.reject(error));
    },
    parseCompanionToVast(enable, type, data, clickThrough, clickTracking) {
      if (!enable || !data) return '';
      const companion_width = this.item.companion_size.split('x')[0];
      const companion_height = this.item.companion_size.split('x')[1];
      let creative = `<Creative><CompanionAds><Companion width="${companion_width}" height="${companion_height}"></Companion></CompanionAds></Creative>`;
      let resource = '';
      let companionClickThrough = '';
      let companionClickTracking = '';
      if (type === 'image') {
        const fileExtension = data.split('.');
        resource = `<StaticResource creativeType="image/${
          fileExtension[fileExtension.length - 1]
        }"> <![CDATA[${data.replace(/[^\x00-\x7F]/g, (c) => encodeURI(c))}]]> </StaticResource>`;
        creative = this.insertBeforeCompanion(creative, resource);
      } else if (type === 'html') {
        resource = `<HTMLResource > <![CDATA[${data}]]> </HTMLResource>`;
        creative = this.insertBeforeCompanion(creative, resource);
      }
      if (clickThrough) {
        companionClickThrough = `<CompanionClickThrough> <![CDATA[${clickThrough.replace(/[^\x00-\x7F]/g, (c) => encodeURI(c))}]]> </CompanionClickThrough>`;
        creative = this.insertBeforeCompanion(creative, companionClickThrough);
      }
      companionClickTracking = `<CompanionClickTracking><![CDATA[{{VIDEO_CLICK}}]]></CompanionClickTracking>
        <CompanionClickTracking><![CDATA[{{CLICK_TRACKING}}]]></CompanionClickTracking>
        <CompanionClickTracking><![CDATA[{{THIRD_PARTY_CLICK_MACRO}}]]></CompanionClickTracking>`;
      if (clickTracking) {
        companionClickTracking =
          companionClickTracking +
          `<CompanionClickTracking><![CDATA[${clickTracking.replace(/[^\x00-\x7F]/g, (c) => encodeURI(c))}]]></CompanionClickTracking> `;
      }
      creative = this.insertBeforeCompanion(creative, companionClickTracking);
      return creative;
    },
    insertBeforeCompanion(creative, insert) {
      if (!creative) return null;
      let tmp = creative.split('</Companion>');
      tmp[0] = tmp[0] + insert + '</Companion>';
      return tmp.join('');
    },
    resetCompanionData() {
      this.item.companion_data = '';
    },
    initCompanion(status) {
      this.item.companion_type = 'image';
      this.item.companion_data = '';
      this.item.companion_size = '';
    },
  },
};
</script>

<style></style>
